<template>
  <div class="d-lg-flex" style="min-height: calc( 100vh - 144px )">
    <div class="chat-leftsidebar w-25 pr-4 pt-3" style="border-right: 1px solid #DADCE3">
      <div>
        <simplebar style="max-height: 490px" class="pr-4" id="scrollElement" data-simplebar-auto-hide="false">
          <slot name="aside"></slot>
        </simplebar>
        </div>
    </div>
    <div class="w-100 mt-4 mt-sm-0" >
      <div class="pt-3 pl-lg-4" style="letter-spacing: 0.02em;">
        <div class="row px-2">
          <slot name="editor"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
export default {
  name: "EditorPage",
  components: { simplebar }      
}
</script>